var installedModules = {};
var moduleToHandlerMapping = {
	67077: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(11855); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	59442: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(75541); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom/client",
	},
	41965: {
		getter: function() { return Promise.all([__webpack_require__.e(6593), __webpack_require__.e(8884)]).then(function() { return function() { return __webpack_require__(9388); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	12974: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(63159); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	89460: {
		getter: function() { return Promise.all([__webpack_require__.e(3186), __webpack_require__.e(7083), __webpack_require__.e(4016), __webpack_require__.e(1965), __webpack_require__.e(1481)]).then(function() { return function() { return __webpack_require__(94016); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/router",
	},
	22376: {
		getter: function() { return __webpack_require__.e(279).then(function() { return function() { return __webpack_require__(12660); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "13.5.9",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	25828: {
		getter: function() { return __webpack_require__.e(984).then(function() { return function() { return __webpack_require__(38603); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "13.5.9",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	50045: {
		getter: function() { return __webpack_require__.e(6514).then(function() { return function() { return __webpack_require__(46514); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^13.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	90323: {
		getter: function() { return __webpack_require__.e(279).then(function() { return function() { return __webpack_require__(12660); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^13.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	61889: {
		getter: function() { return __webpack_require__.e(984).then(function() { return function() { return __webpack_require__(38603); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	91649: {
		getter: function() { return Promise.all([__webpack_require__.e(3186), __webpack_require__.e(4597), __webpack_require__.e(4721)]).then(function() { return function() { return __webpack_require__(64597); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	49115: {
		getter: function() { return Promise.all([__webpack_require__.e(7083), __webpack_require__.e(1965), __webpack_require__.e(2975)]).then(function() { return function() { return __webpack_require__(46514); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	77865: {
		getter: function() { return Promise.all([__webpack_require__.e(8188), __webpack_require__.e(1965), __webpack_require__.e(4118)]).then(function() { return function() { return __webpack_require__(98188); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	},
	46833: {
		getter: function() { return __webpack_require__.e(279).then(function() { return function() { return __webpack_require__(12660); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	89888: {
		getter: function() { return __webpack_require__.e(7335).then(function() { return function() { return __webpack_require__(79716); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx",
	},
	38449: {
		getter: function() { return __webpack_require__.e(5954).then(function() { return function() { return __webpack_require__(83573); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx/style",
	},
	43216: {
		getter: function() { return __webpack_require__.e(6514).then(function() { return function() { return __webpack_require__(46514); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "13.5.9",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	52224: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(18959); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom/server",
	},
	13564: {
		getter: function() { return __webpack_require__.e(4597).then(function() { return function() { return __webpack_require__(64597); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "13.5.9",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	28424: {
		getter: function() { return __webpack_require__.e(8188).then(function() { return function() { return __webpack_require__(98188); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "13.5.9",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	}
};
var initialConsumes = [67077,59442,41965,12974,89460,22376,25828,50045,90323,43216,52224,13564,28424];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
var chunkMapping = {
	"636": [
		12974,
		89460,
		22376,
		25828,
		50045,
		90323
	],
	"1965": [
		41965
	],
	"3564": [
		13564
	],
	"5120": [
		61889,
		89460,
		91649,
		49115,
		77865,
		46833,
		89888,
		38449,
		12974
	],
	"5747": [
		43216,
		52224
	],
	"8792": [
		67077,
		59442,
		41965
	],
	"8884": [
		67077
	],
	"8920": [
		28424
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}